import { render, staticRenderFns } from "./MyPip.vue?vue&type=template&id=4e7608ba&scoped=true&"
import script from "./MyPip.vue?vue&type=script&lang=js&"
export * from "./MyPip.vue?vue&type=script&lang=js&"
import style0 from "./MyPip.vue?vue&type=style&index=0&id=4e7608ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7608ba",
  null
  
)

export default component.exports